import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="currentColor" />
      <circle cx="15" cy="15" r="6" stroke="white" stroke-width="2" class="loader-icons-bar" />
    </svg>
  );
};

export default Icon;
